module.exports = __webpack_public_path__ + "img/slider_galery_19.a1adf445.jpg";